'use client';

import { Collapsible as BaseCollapsible } from '@base-ui/react/collapsible';

import { cn } from '../lib/utils';

/**
 * Collapsible — shadcn-style compound component built on Base UI's
 * Collapsible primitive.
 *
 * Supports controlled (`open` + `onOpenChange`) or uncontrolled (`defaultOpen`).
 * Use CollapsibleContent's data-[state] attributes to target open/closed
 * styles (e.g. for chevron rotation).
 */

const Collapsible = BaseCollapsible.Root;
const CollapsibleTrigger = BaseCollapsible.Trigger;

function CollapsibleContent({
  className,
  ...props
}: BaseCollapsible.Panel.Props) {
  return (
    <BaseCollapsible.Panel
      className={cn(
        'overflow-hidden',
        'data-[ending-style]:h-0 data-[starting-style]:h-0',
        className,
      )}
      {...props}
    />
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
